export default (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }

  return /^[a-zA-Z -]*$/.test(value);
};



// WEBPACK FOOTER //
// ./src/utils/validators/AlphaWhite.js